// cspell:disable

/**
 * --- DO NOT MODIFY THIS FILE ---------------------------------------------------------------------
 *
 * This file is automatically generated using generator/generate-environment.ts. If you wish to
 * change the environment variables, modify the file config/environment.yaml and then run:
 *
 *     npm run generate:environment
 *
 * -------------------------------------------------------------------------------------------------
 */

import getenv from 'env/getenv';

/**
 * Whether the feature is on.
 */
function isFeatureOn(feature: string): boolean {
  return feature === 'on';
}

/**
 * The base url of the REST API.
 */
export const REST_API_URL =
  process.env.REACT_APP_REST_API_URL ||
  getenv('REST_API_URL', {
    development: '/',
    test: '/',
    production: '/',
  });

/**
 * The timeout for the REST API.
 */
export const REST_API_TIMEOUT = Number(
  process.env.REACT_APP_REST_API_TIMEOUT ||
    getenv('REST_API_TIMEOUT', {
      development: '60000',
      test: '60000',
      production: '60000',
    })
);

/**
 * The host of the web app.
 */
export const WEB_APP_HOST =
  process.env.REACT_APP_WEB_APP_HOST ||
  getenv('WEB_APP_HOST', {
    development: 'http://localhost:3000',
    test: 'http://localhost:3000',
    production: '',
  });

/**
 * The maximum size of a file upload in bytes.
 */
export const FILE_UPLOAD_MAX_SIZE = Number(
  process.env.REACT_APP_FILE_UPLOAD_MAX_SIZE ||
    getenv('FILE_UPLOAD_MAX_SIZE', {
      development: 524288000,
      test: 524288000,
      production: '524288000',
    })
);

/**
 * The timeout for the file manager.
 */
export const FILE_MANAGER_TIMEOUT = Number(
  process.env.REACT_APP_FILE_MANAGER_TIMEOUT ||
    getenv('FILE_MANAGER_TIMEOUT', {
      development: '60000',
      test: '60000',
      production: '60000',
    })
);

/**
 * The base url of the file manager.
 */
export const FILE_MANAGER_URL =
  process.env.REACT_APP_FILE_MANAGER_URL ||
  getenv('FILE_MANAGER_URL', {
    development: '/api/files',
    test: '/api/files',
    production: '/api/files',
  });

/**
 * Whether to use Firebase.
 */
export const FEATURE_TOGGLE_FIREBASE = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_FIREBASE ||
    getenv('FEATURE_TOGGLE_FIREBASE', {
      development: 'off',
      test: 'off',
      production: 'off',
    })
);

/**
 * The API key for Firebase.
 */
export const FIREBASE_API_KEY =
  process.env.REACT_APP_FIREBASE_API_KEY ||
  getenv('FIREBASE_API_KEY', {
    development: '',
    test: '',
    production: '__________',
  });

/**
 * The auth domain for Firebase.
 */
export const FIREBASE_AUTH_DOMAIN =
  process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
  getenv('FIREBASE_AUTH_DOMAIN', {
    development: '',
    test: '',
    production: '__________',
  });

/**
 * The project id for Firebase.
 */
export const FIREBASE_PROJECT_ID =
  process.env.REACT_APP_FIREBASE_PROJECT_ID ||
  getenv('FIREBASE_PROJECT_ID', {
    development: '',
    test: '',
    production: '__________',
  });

/**
 * The storage bucket for Firebase.
 */
export const FIREBASE_STORAGE_BUCKET =
  process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
  getenv('FIREBASE_STORAGE_BUCKET', {
    development: '',
    test: '',
    production: '__________',
  });

/**
 * The messaging sender id for Firebase.
 */
export const FIREBASE_MESSAGING_SENDER_ID =
  process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ||
  getenv('FIREBASE_MESSAGING_SENDER_ID', {
    development: '',
    test: '',
    production: '__________',
  });

/**
 * The app id for Firebase.
 */
export const FIREBASE_APP_ID =
  process.env.REACT_APP_FIREBASE_APP_ID ||
  getenv('FIREBASE_APP_ID', {
    development: '',
    test: '',
    production: '__________',
  });

/**
 * Whether to allow KEP.
 */
export const FEATURE_TOGGLE_KEP = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_KEP ||
    getenv('FEATURE_TOGGLE_KEP', {
      development: 'on',
      test: 'off',
      production: 'on',
    })
);

/**
 * Whether to allow Test Page.
 */
export const FEATURE_TOGGLE_TEST_PAGE = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_TEST_PAGE ||
    getenv('FEATURE_TOGGLE_TEST_PAGE', {
      development: 'on',
      test: 'off',
      production: '',
    })
);

/**
 * Whether to allow Create Device Subtypes.
 */
export const FEATURE_TOGGLE_CREATE_DEVICE_SUBTYPES = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_CREATE_DEVICE_SUBTYPES ||
    getenv('FEATURE_TOGGLE_CREATE_DEVICE_SUBTYPES', {
      development: 'on',
      test: 'off',
      production:
        'on',
    })
);

/**
 * The target for window.open when using Brain IT.
 */
export const BRAIN_IT_WINDOW_OPEN_TARGET =
  process.env.REACT_APP_BRAIN_IT_WINDOW_OPEN_TARGET ||
  getenv('BRAIN_IT_WINDOW_OPEN_TARGET', {
    development: '_blank',
    test: '_blank',
    production: '_self',
  });

/**
 * Whether to allow the admins to see Revision Templates pages.
 */
export const FEATURE_TOGGLE_BROWSE_REVISION_TEMPLATES = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_BROWSE_REVISION_TEMPLATES ||
    getenv('FEATURE_TOGGLE_BROWSE_REVISION_TEMPLATES', {
      development: 'on',
      test: 'off',
      production:
        'on',
    })
);

/**
 * Whether to allow users to define evidence fields in device subtype form
 */
export const FEATURE_TOGGLE_DEVICE_SUBTYPE_EVIDENCE_FIELDS = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_DEVICE_SUBTYPE_EVIDENCE_FIELDS ||
    getenv('FEATURE_TOGGLE_DEVICE_SUBTYPE_EVIDENCE_FIELDS', {
      development: 'on',
      test: 'off',
      production:
        'on',
    })
);

/**
 * Whether to allow the technicians to see the modal with changes made in revision form
 */
export const FEATURE_TOGGLE_REVISION_CHANGES_MODAL = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_REVISION_CHANGES_MODAL ||
    getenv('FEATURE_TOGGLE_REVISION_CHANGES_MODAL', {
      development: 'on',
      test: 'off',
      production:
        'on',
    })
);

/**
 * Whether to allow the users to see the slider with device images
 */
export const FEATURE_TOGGLE_DEVICE_IMAGES_SLIDER = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_DEVICE_IMAGES_SLIDER ||
    getenv('FEATURE_TOGGLE_DEVICE_IMAGES_SLIDER', {
      development: 'on',
      test: 'off',
      production: 'on',
    })
);

/**
 * The destination the user is redirected to after updating company settings
 */
export const COMPANY_SETTINGS_REDIRECT_AFTER_SAVE =
  process.env.REACT_APP_COMPANY_SETTINGS_REDIRECT_AFTER_SAVE ||
  getenv('COMPANY_SETTINGS_REDIRECT_AFTER_SAVE', {
    development: 'list',
    test: 'list',
    production: 'list',
  });

/**
 * The destination the user is redirected to after updating a department
 */
export const DEPARTMENT_REDIRECT_AFTER_SAVE =
  process.env.REACT_APP_DEPARTMENT_REDIRECT_AFTER_SAVE ||
  getenv('DEPARTMENT_REDIRECT_AFTER_SAVE', {
    development: 'same',
    test: 'same',
    production: 'list',
  });

/**
 * The destination the user is redirected to after updating a device
 */
export const DEVICE_REDIRECT_AFTER_SAVE =
  process.env.REACT_APP_DEVICE_REDIRECT_AFTER_SAVE ||
  getenv('DEVICE_REDIRECT_AFTER_SAVE', {
    development: 'same',
    test: 'same',
    production: 'same',
  });

/**
 * The destination the user is redirected to after updating a device subtype
 */
export const DEVICE_SUBTYPE_REDIRECT_AFTER_SAVE =
  process.env.REACT_APP_DEVICE_SUBTYPE_REDIRECT_AFTER_SAVE ||
  getenv('DEVICE_SUBTYPE_REDIRECT_AFTER_SAVE', {
    development: 'list',
    test: 'list',
    production: 'list',
  });

/**
 * The destination the user is redirected to after updating a measuring device
 */
export const MEASURING_DEVICE_REDIRECT_AFTER_SAVE =
  process.env.REACT_APP_MEASURING_DEVICE_REDIRECT_AFTER_SAVE ||
  getenv('MEASURING_DEVICE_REDIRECT_AFTER_SAVE', {
    development: 'list',
    test: 'list',
    production: 'list',
  });

/**
 * The destination the user is redirected to after updating a certificate
 */
export const MY_CERTIFICATES_REDIRECT_AFTER_SAVE =
  process.env.REACT_APP_MY_CERTIFICATES_REDIRECT_AFTER_SAVE ||
  getenv('MY_CERTIFICATES_REDIRECT_AFTER_SAVE', {
    development: 'list',
    test: 'list',
    production: 'list',
  });

/**
 * The destination the user is redirected to after updating their profile
 */
export const MY_PROFILE_REDIRECT_AFTER_SAVE =
  process.env.REACT_APP_MY_PROFILE_REDIRECT_AFTER_SAVE ||
  getenv('MY_PROFILE_REDIRECT_AFTER_SAVE', {
    development: 'list',
    test: 'list',
    production: 'list',
  });

/**
 * The destination the user is redirected to after updating an organization
 */
export const ORGANIZATION_REDIRECT_AFTER_SAVE =
  process.env.REACT_APP_ORGANIZATION_REDIRECT_AFTER_SAVE ||
  getenv('ORGANIZATION_REDIRECT_AFTER_SAVE', {
    development: 'same',
    test: 'same',
    production: 'list',
  });

/**
 * The destination the user is redirected to after updating predefined data
 */
export const PREDEFINED_DATA_REDIRECT_AFTER_SAVE =
  process.env.REACT_APP_PREDEFINED_DATA_REDIRECT_AFTER_SAVE ||
  getenv('PREDEFINED_DATA_REDIRECT_AFTER_SAVE', {
    development: 'list',
    test: 'list',
    production: 'list',
  });

/**
 * The destination the user is redirected to after updating a revision
 */
export const REVISION_REDIRECT_AFTER_SAVE =
  process.env.REACT_APP_REVISION_REDIRECT_AFTER_SAVE ||
  getenv('REVISION_REDIRECT_AFTER_SAVE', {
    development: 'list',
    test: 'list',
    production: 'list',
  });

/**
 * The destination the user is redirected to after updating a revision template
 */
export const REVISION_TEMPLATE_REDIRECT_AFTER_SAVE =
  process.env.REACT_APP_REVISION_TEMPLATE_REDIRECT_AFTER_SAVE ||
  getenv('REVISION_TEMPLATE_REDIRECT_AFTER_SAVE', {
    development: 'list',
    test: 'list',
    production: 'list',
  });

/**
 * The destination the user is redirected to after updating a user
 */
export const USER_REDIRECT_AFTER_SAVE =
  process.env.REACT_APP_USER_REDIRECT_AFTER_SAVE ||
  getenv('USER_REDIRECT_AFTER_SAVE', {
    development: 'same',
    test: 'same',
    production: 'list',
  });

/**
 * Whether to allow the admins to see the Revision Template Editor
 */
export const FEATURE_TOGGLE_REVISION_TEMPLATE_EDITOR = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_REVISION_TEMPLATE_EDITOR ||
    getenv('FEATURE_TOGGLE_REVISION_TEMPLATE_EDITOR', {
      development: 'on',
      test: 'off',
      production:
        'on',
    })
);

/**
 * Whether to allow the admins to see the Revision Template Editor Automations
 */
export const FEATURE_TOGGLE_REVISION_TEMPLATE_EDITOR_AUTOMATIONS = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_REVISION_TEMPLATE_EDITOR_AUTOMATIONS ||
    getenv('FEATURE_TOGGLE_REVISION_TEMPLATE_EDITOR_AUTOMATIONS', {
      development: 'on',
      test: 'off',
      production:
        'on',
    })
);

/**
 * Whether to allow the admins to see the Revision Plan Change Log
 */
export const FEATURE_TOGGLE_REVISION_PLAN_CHANGE_LOG = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_REVISION_PLAN_CHANGE_LOG ||
    getenv('FEATURE_TOGGLE_REVISION_PLAN_CHANGE_LOG', {
      development: 'on',
      test: 'off',
      production:
        '',
    })
);

/**
 * Whether to show the device id in the revision fill out form
 */
export const FEATURE_TOGGLE_SHOW_DEVICE_ID_IN_REVISION_FILL_OUT_FORM = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_SHOW_DEVICE_ID_IN_REVISION_FILL_OUT_FORM ||
    getenv('FEATURE_TOGGLE_SHOW_DEVICE_ID_IN_REVISION_FILL_OUT_FORM', {
      development: 'off',
      test: 'off',
      production:
        '',
    })
);

/**
 * Whether to allow the revision technicians to select group by organization
 */
export const FEATURE_TOGGLE_REVISION_TECHNICIAN_SELECT_GROUP_BY_ORGANIZATION = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_REVISION_TECHNICIAN_SELECT_GROUP_BY_ORGANIZATION ||
    getenv('FEATURE_TOGGLE_REVISION_TECHNICIAN_SELECT_GROUP_BY_ORGANIZATION', {
      development: 'on',
      test: 'off',
      production:
        'on',
    })
);

/**
 * The size of a chunk for file upload in bytes.
 */
export const FILE_UPLOAD_CHUNK_SIZE = Number(
  process.env.REACT_APP_FILE_UPLOAD_CHUNK_SIZE ||
    getenv('FILE_UPLOAD_CHUNK_SIZE', {
      development: 262144,
      test: 262144,
      production: '262144',
    })
);

/**
 * Whether to show a confirmation dialog before leaving a form
 */
export const FEATURE_TOGGLE_FORM_CONFIRMATION_BEFORE_LEAVE = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_FORM_CONFIRMATION_BEFORE_LEAVE ||
    getenv('FEATURE_TOGGLE_FORM_CONFIRMATION_BEFORE_LEAVE', {
      development: 'off',
      test: 'off',
      production:
        '',
    })
);

/**
 * Whether to allow the users to see the export page
 */
export const FEATURE_TOGGLE_EXPORT_PAGE = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_EXPORT_PAGE ||
    getenv('FEATURE_TOGGLE_EXPORT_PAGE', {
      development: 'on',
      test: 'off',
      production: 'on',
    })
);

/**
 * Whether to allow the users to download all device files
 */
export const FEATURE_TOGGLE_DOWNLOAD_ALL_DEVICE_FILES = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_DOWNLOAD_ALL_DEVICE_FILES ||
    getenv('FEATURE_TOGGLE_DOWNLOAD_ALL_DEVICE_FILES', {
      development: 'on',
      test: 'off',
      production:
        '',
    })
);

/**
 * The number of parallel tasks when doing system export
 */
export const SYSTEM_EXPORT_PARALLELISM = Number(
  process.env.REACT_APP_SYSTEM_EXPORT_PARALLELISM ||
    getenv('SYSTEM_EXPORT_PARALLELISM', {
      development: '5',
      test: '5',
      production: '',
    })
);

/**
 * Whether to allow the technicians to copy revision data
 */
export const FEATURE_TOGGLE_TECHNICIAN_COPY_REVISION_DATA = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_TECHNICIAN_COPY_REVISION_DATA ||
    getenv('FEATURE_TOGGLE_TECHNICIAN_COPY_REVISION_DATA', {
      development: 'on',
      test: 'off',
      production:
        'on',
    })
);

/**
 * Whether parent device functionality is enabled
 */
export const FEATURE_TOGGLE_PARENT_DEVICE = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_PARENT_DEVICE ||
    getenv('FEATURE_TOGGLE_PARENT_DEVICE', {
      development: 'on',
      test: 'off',
      production: 'on',
    })
);

/**
 * Whether to allow the admins to set font style in the Revision Template Editor
 */
export const FEATURE_TOGGLE_REVISION_TEMPLATE_EDITOR_FONT_STYLE = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_REVISION_TEMPLATE_EDITOR_FONT_STYLE ||
    getenv('FEATURE_TOGGLE_REVISION_TEMPLATE_EDITOR_FONT_STYLE', {
      development: 'on',
      test: 'off',
      production:
        'on',
    })
);

/**
 * The title of the HTML pages.
 */
export const HTML_TITLE =
  process.env.REACT_APP_HTML_TITLE ||
  getenv('HTML_TITLE', {
    development: 'Objekto',
    test: 'Objekto',
    production: 'Objekto DEMO',
  });

/**
 * Whether to allow users to see evidence fields in device table
 */
export const FEATURE_TOGGLE_EVIDENCE_FIELDS_IN_DEVICE_TABLE = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_EVIDENCE_FIELDS_IN_DEVICE_TABLE ||
    getenv('FEATURE_TOGGLE_EVIDENCE_FIELDS_IN_DEVICE_TABLE', {
      development: 'on',
      test: 'off',
      production:
        'on',
    })
);

/**
 * Whether to allow the users to see revision pipeline confirmations
 */
export const FEATURE_TOGGLE_REVISION_PIPELINE_GATHER_CONFIRMATION = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_REVISION_PIPELINE_GATHER_CONFIRMATION ||
    getenv('FEATURE_TOGGLE_REVISION_PIPELINE_GATHER_CONFIRMATION', {
      development: 'on',
      test: 'off',
      production:
        'on',
    })
);

/**
 * Whether to allow the admins to generate PDFs for revisions
 */
export const FEATURE_TOGGLE_REVISION_ADMIN_GENERATE_PDF = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_REVISION_ADMIN_GENERATE_PDF ||
    getenv('FEATURE_TOGGLE_REVISION_ADMIN_GENERATE_PDF', {
      development: 'on',
      test: 'off',
      production:
        'on',
    })
);

/**
 * Whether to allow auto saving drafts in revision fill out form
 */
export const FEATURE_TOGGLE_REVISION_AUTO_SAVE_DRAFT = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_REVISION_AUTO_SAVE_DRAFT ||
    getenv('FEATURE_TOGGLE_REVISION_AUTO_SAVE_DRAFT', {
      development: 'on',
      test: 'off',
      production:
        'on',
    })
);

/**
 * Whether to allow remote sources functionality
 */
export const FEATURE_TOGGLE_REMOTE_SOURCES = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_REMOTE_SOURCES ||
    getenv('FEATURE_TOGGLE_REMOTE_SOURCES', {
      development: 'on',
      test: 'off',
      production: 'on',
    })
);

/**
 * Whether to allow Bulk Sign Revision.
 */
export const FEATURE_TOGGLE_BULK_SIGN_REVISION = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_BULK_SIGN_REVISION ||
    getenv('FEATURE_TOGGLE_BULK_SIGN_REVISION', {
      development: 'on',
      test: 'off',
      production: '',
    })
);

/**
 * Whether to allow copying devices
 */
export const FEATURE_TOGGLE_COPY_DEVICE = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_COPY_DEVICE ||
    getenv('FEATURE_TOGGLE_COPY_DEVICE', {
      development: 'on',
      test: 'off',
      production: '',
    })
);

/**
 * Whether to allow bulk creating revisions
 */
export const FEATURE_TOGGLE_BULK_CREATE_REVISION = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_BULK_CREATE_REVISION ||
    getenv('FEATURE_TOGGLE_BULK_CREATE_REVISION', {
      development: 'on',
      test: 'off',
      production: '',
    })
);

/**
 * Whether to allow moving devices between departments
 */
export const FEATURE_TOGGLE_MOVE_DEVICE_BETWEEN_DEPARTMENTS = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_MOVE_DEVICE_BETWEEN_DEPARTMENTS ||
    getenv('FEATURE_TOGGLE_MOVE_DEVICE_BETWEEN_DEPARTMENTS', {
      development: 'on',
      test: 'off',
      production:
        '',
    })
);

/**
 * Whether to allow creating revisions without assigning a technician in the revision fill out form
 */
export const FEATURE_TOGGLE_REVISION_FORM_ALLOW_CREATE_WITHOUT_TECHNICIAN = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_REVISION_FORM_ALLOW_CREATE_WITHOUT_TECHNICIAN ||
    getenv('FEATURE_TOGGLE_REVISION_FORM_ALLOW_CREATE_WITHOUT_TECHNICIAN', {
      development: 'on',
      test: 'off',
      production:
        '',
    })
);

/**
 * Whether to allow admins to impersonate other users
 */
export const FEATURE_TOGGLE_ADMIN_IMPERSONATE_USER = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_ADMIN_IMPERSONATE_USER ||
    getenv('FEATURE_TOGGLE_ADMIN_IMPERSONATE_USER', {
      development: 'on',
      test: 'off',
      production:
        'off',
    })
);

/**
 * Whether to allow using code editor in input configurator
 */
export const FEATURE_TOGGLE_CODE_EDITOR_IN_INPUT_CONFIGURATOR = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_CODE_EDITOR_IN_INPUT_CONFIGURATOR ||
    getenv('FEATURE_TOGGLE_CODE_EDITOR_IN_INPUT_CONFIGURATOR', {
      development: 'on',
      test: 'off',
      production:
        '',
    })
);

/**
 * Whether to allow the users to see different view variants for the revision table
 */
export const FEATURE_TOGGLE_REVISION_TABLE_VIEW_VARIANT = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_REVISION_TABLE_VIEW_VARIANT ||
    getenv('FEATURE_TOGGLE_REVISION_TABLE_VIEW_VARIANT', {
      development: 'on',
      test: 'off',
      production:
        '',
    })
);

/**
 * Whether to allow admins to save signed documents again
 */
export const FEATURE_TOGGLE_SAVE_SIGNED_DOC_AGAIN_ACTION = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_SAVE_SIGNED_DOC_AGAIN_ACTION ||
    getenv('FEATURE_TOGGLE_SAVE_SIGNED_DOC_AGAIN_ACTION', {
      development: 'on',
      test: 'off',
      production:
        '',
    })
);

/**
 * Whether to show the device link in the revision fill out form
 */
export const FEATURE_TOGGLE_SHOW_DEVICE_LINK_IN_REVISION_FILL_OUT_FORM = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_SHOW_DEVICE_LINK_IN_REVISION_FILL_OUT_FORM ||
    getenv('FEATURE_TOGGLE_SHOW_DEVICE_LINK_IN_REVISION_FILL_OUT_FORM', {
      development: 'on',
      test: 'off',
      production:
        '',
    })
);

/**
 * Whether to allow showing index values columns in the revision table
 */
export const FEATURE_TOGGLE_REVISION_TABLE_INDEX_VALUES_COLUMNS = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_REVISION_TABLE_INDEX_VALUES_COLUMNS ||
    getenv('FEATURE_TOGGLE_REVISION_TABLE_INDEX_VALUES_COLUMNS', {
      development: 'on',
      test: 'off',
      production:
        '',
    })
);

/**
 * Whether to allow showing evidence fields columns in the revision table
 */
export const FEATURE_TOGGLE_REVISION_TABLE_EVIDENCE_FIELDS_COLUMNS = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_REVISION_TABLE_EVIDENCE_FIELDS_COLUMNS ||
    getenv('FEATURE_TOGGLE_REVISION_TABLE_EVIDENCE_FIELDS_COLUMNS', {
      development: 'on',
      test: 'off',
      production:
        '',
    })
);

/**
 * Whether to allow showing evidence fields columns in the revision plan table
 */
export const FEATURE_TOGGLE_EVIDENCE_FIELDS_IN_REVISION_PLAN_TABLE = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_EVIDENCE_FIELDS_IN_REVISION_PLAN_TABLE ||
    getenv('FEATURE_TOGGLE_EVIDENCE_FIELDS_IN_REVISION_PLAN_TABLE', {
      development: 'on',
      test: 'off',
      production:
        '',
    })
);

/**
 * Short git commit hash used for this build.
 */
export const BUILD_COMMIT_HASH =
  process.env.REACT_APP_BUILD_COMMIT_HASH ||
  getenv('BUILD_COMMIT_HASH', {
    development: 'ewkfkzh1fcnmxu7o75mg35oj8531amvobuild_commit_hashshzbpkgwlzuufkgkpahqs3brbcjbujsa',
    test: 'ewkfkzh1fcnmxu7o75mg35oj8531amvobuild_commit_hashshzbpkgwlzuufkgkpahqs3brbcjbujsa',
    production: '3f3da8a9',
  });

/**
 * Whether to allow showing user signatures in the users table
 */
export const FEATURE_TOGGLE_SIGNATURE_IN_USERS_TABLE = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_SIGNATURE_IN_USERS_TABLE ||
    getenv('FEATURE_TOGGLE_SIGNATURE_IN_USERS_TABLE', {
      development: 'on',
      test: 'off',
      production:
        '',
    })
);

/**
 * Whether to allow admins to access the secret impersonate page
 */
export const FEATURE_TOGGLE_ADMIN_IMPERSONATE_SECRET_PAGE = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_ADMIN_IMPERSONATE_SECRET_PAGE ||
    getenv('FEATURE_TOGGLE_ADMIN_IMPERSONATE_SECRET_PAGE', {
      development: 'on',
      test: 'off',
      production:
        'on',
    })
);

/**
 * Secret segment used in the admin impersonate page URL
 */
export const ADMIN_IMPERSONATE_SECRET_PATH_SEGMENT =
  process.env.REACT_APP_ADMIN_IMPERSONATE_SECRET_PATH_SEGMENT ||
  getenv('ADMIN_IMPERSONATE_SECRET_PATH_SEGMENT', {
    development: 'admin-impersonate-link',
    test: 'admin-impersonate-link',
    production: '005d0a37-ef1e-419e-9461-ddfc7fd0c169',
  });

/**
 * Whether to show the two factor authentication subform in My Profile
 */
export const FEATURE_TOGGLE_MY_PROFILE_TWO_FACTOR = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_MY_PROFILE_TWO_FACTOR ||
    getenv('FEATURE_TOGGLE_MY_PROFILE_TWO_FACTOR', {
      development: 'on',
      test: 'off',
      production:
        'on',
    })
);

/**
 * Whether to show KEP signing maintenance notices instead of the normal signing content
 */
export const FEATURE_TOGGLE_KEP_MAINTENANCE = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_KEP_MAINTENANCE ||
    getenv('FEATURE_TOGGLE_KEP_MAINTENANCE', {
      development: 'on',
      test: 'off',
      production: '',
    })
);

/**
 * The message shown when KEP signing is under maintenance
 */
export const KEP_MAINTENANCE_MESSAGE =
  process.env.REACT_APP_KEP_MAINTENANCE_MESSAGE ||
  getenv('KEP_MAINTENANCE_MESSAGE', {
    development: 'KEP podpisovanie je momentálne v údržbe. Skúste to prosím neskôr.',
    test: '',
    production: '',
  });

/**
 * Whether to enable the price offer module
 */
export const FEATURE_TOGGLE_PRICE_OFFERS = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_PRICE_OFFERS ||
    getenv('FEATURE_TOGGLE_PRICE_OFFERS', {
      development: 'on',
      test: 'off',
      production: '',
    })
);

/**
 * Whether to show revision lock debug diagnostics in the fill out form
 */
export const FEATURE_TOGGLE_REVISION_LOCK_DEBUG_PANEL = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_REVISION_LOCK_DEBUG_PANEL ||
    getenv('FEATURE_TOGGLE_REVISION_LOCK_DEBUG_PANEL', {
      development: 'on',
      test: 'off',
      production:
        '',
    })
);

/**
 * Whether to enable the complete HR module web surface
 */
export const FEATURE_TOGGLE_HR_MODULE = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_HR_MODULE ||
    getenv('FEATURE_TOGGLE_HR_MODULE', {
      development: 'on',
      test: 'off',
      production: '',
    })
);

/**
 * Whether to enable device QR pairing and navigation
 */
export const FEATURE_TOGGLE_DEVICE_QR_CODES = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_DEVICE_QR_CODES ||
    getenv('FEATURE_TOGGLE_DEVICE_QR_CODES', {
      development: 'on',
      test: 'off',
      production: '',
    })
);

/**
 * Whether to allow editing the user email override for NFQES signing
 */
export const FEATURE_TOGGLE_USER_NFQES_EMAIL = isFeatureOn(
  process.env.REACT_APP_FEATURE_TOGGLE_USER_NFQES_EMAIL ||
    getenv('FEATURE_TOGGLE_USER_NFQES_EMAIL', {
      development: 'on',
      test: 'off',
      production: '',
    })
);
